<template>
  <v-container style="height: 100%"  v-if="$route.name === 'ListCandidate_case'">

    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Аттестационные дела соискателей:</span>
        <v-spacer></v-spacer>
        <v-btn @click="opened_form = true" color="secondary" flat>
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
        <v-btn @click="getItems()" color="primary" icon flat><v-icon>update</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table
              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="total"
              :loading="loading"
              class="elevation-1"
              :rows-per-page-items="[10,15,100]"
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center">
                  <div  v-for="item, i in props.item.lastName">
                    {{item.text}}
                  </div>
                </td>
                <td class="justify-center">
                  <div  v-for="item, i in props.item.firstName">
                    {{item.text}}
                  </div>
                </td>
                <td class="justify-center">
                  <div  v-for="item, i in props.item.patronymic">
                    {{item.text}}
                  </div>
                </td>
                <td class="justify-center">
                  <div  v-for="item, i in props.item.thesisTopic">
                    {{item.text}}
                  </div>
                </td>

                <td class="justify-center " v-bind="selected">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openQRPage(props.item)"
                        medium
                      >
                        qr_code
                      </v-icon>
                    </template>
                    <span>QR страница</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openPrintQr(props.item)"
                        medium
                      >
                        print
                      </v-icon>
                    </template>
                    <span>QR печвть</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateItem(props.item)"
                        class="mr-2"
                        medium
                      >
                        edit
                      </v-icon>
                    </template>
                    <span>Редактировать</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openConfirmDelete(props.item)"
                        medium
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>

          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog @input="closedForm" v-model="opened_form" fullscreen hide-overlay transition="dialog-bottom-transition">
      <Candidate_case @addItem="addItem"
                    @ended="closedForm"
                    @refreshItem="refreshItem"
                    v-bind="selected"
                    v-if="opened_form"
      >
      </Candidate_case>
    </v-dialog>

    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--</v-flex>-->
    <!--</v-layout>-->
  </v-container>
  <router-view v-else :key="$route.fullPath"></router-view>
</template>


<script>
    import Candidate_case  from "../forms/Candidate_case"
    import urls from "../../../../../modules/petition/urls"
    import UserDataMixin from '../../../../../mixins/UserDataMixin'
    import {makeGetRequest} from "../../../../../helper";

    export default {
        name: "ListCandidate_case",
        components: {Candidate_case},
        mixins: [UserDataMixin],

        data () {
            return {
                URL_LIST: urls.getUrl('admin|case|models|candidate_case-list', 'list'),
                URL_DELETE: urls.getUrl('admin|case|models|candidate_case-detail', 'destroy'),

                total: 0,
                items: [],
                loading: true,
                pagination: {},
                headers: [
                    {
                        text: 'Фамилия', sortable: false, align: 'justify-center',
                    },
                    {
                        text: 'Имя', sortable: false, align: 'justify-center',
                    },
                    {
                        text: 'Отчество', sortable: false, align: 'justify-center',
                    },
                    {
                        text: 'Тема', sortable: false, align: 'justify-center',
                    },
                    {
                        text: 'Действия', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    }
                ]
            }
        },
        watch: {
            pagination: {
                handler () {
                    this.getItems()
                },
                deep: true
            }
        },
        mounted () {
            this.getItems()
        },
        methods: {
            addItem(){
                this.closedForm()
                this.getItems();
            },
            openPrintQr(item){
              this.$router.push({name: 'QRPrint',params:{'uid':item.uid}})
            },
            openQRPage(item){
              this.$router.push({name: 'QRPage',params:{'uid':item.uid}})
            },
            getItems () {
                this.loading = true
                let url =  this.URL_LIST+"?page="+this.pagination.page +"&page_size="+ this.pagination.rowsPerPage
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }) .then(json => {
                    this.items = json.results
                    this.total = json.count
                    this.loading = false
                })
            },
        }
    }


</script>
<style scoped>

</style>
